/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

function defaultTransform(defaults, single, userCache) {

  // We can't guarantee that the default transformation is an array
  defaults = angular.isArray(defaults) ? defaults : [defaults];

  // Append the new transformation to the defaults
  return defaults.concat(function (response) {
    if (response.data && response.data.message) {
      userCache.put('lastErrorMessage', response.data.message);
      userCache.put('lastErrorInfo', response.data.info);
      userCache.put('lastErrorCode', response.data.error);
    }

    return !response.data || !response.data.results ?
      response : (single ? response.data.results[0] : response.data.results);
  });
}

/**
 * @ngdoc module
 * @name b17Resource
 * @description
 *
 * # b17Resource
 *
 * The `b17Resource` module provides interaction support with RESTful services
 * via the $resource service.
 */
angular.module("b17Resource", [])
/**
 * @ngdoc service
 * @name b17Service
 * @requires $http, $resource
 *
 * @description
 * A data provider which creates a resource object that lets you interact with
 * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
 */
  .provider("b17Service", function () {

    var url = "please use config to init";
    var cache = true;
    var prefix = "/api/v1/";

    this.setUrl = function (newURL) {
      url = newURL;
    };

    this.useCache = function (status) {
      cache = status;
    };

    this.$get = function ($http, $resource, $cacheFactory, userCache) {

      return {

        // config data model
        config: $resource(
          url + prefix + "config",
          {},
          {
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // groups data model
        groups: $resource(
          url + prefix + "groups/:name",
          { name: "@name" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // providers data model
        providers: $resource(
          url + prefix + "providers/:name",
          { name: "@name" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            add: {
              method: 'PUT',
              params: {name: null},
              transformRequest: function (data) {
                  return angular.toJson([data]);
              },
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // products data model
        products: $resource(
          url + prefix + "products/:group/:name",
          { group: "@group", name: "@name" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            add: {
              method: 'PUT',
              params: {group: null, name: null,},
              transformRequest: function (data) {
                  return angular.toJson([data]);
              },
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // versions data model
        versions: $resource(
          url + prefix + "versions/:number",
          { number: "@number" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            create: {
              method: 'POST',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // price data model
        price: $resource(
          url + prefix + "prices/:group/:product/:provider/:article/:operation/:quantity",
          { 
            group: "@group",
            product: "@product",
            provider: "@provider",
            article: "@article",
            operation: "@operation",
            quantity: "@quantity",
          },
          { 
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // prices data model
        prices: $resource(
          url + prefix + "prices/:group/:product/:provider",
          { group: "@group", product: "@product", provider: "@provider"},
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            add: {
              method: 'PUT',
              params: {group: null, product: null, provider: null},
              transformRequest: function (data) {
                  return angular.toJson([data]);
              },
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // promotions data model
        promotions: $resource(
          url + prefix + "promotions/:id",
          { id: "@id" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            create: {
              method: 'POST',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // clients data model
        clients: $resource(
          url + prefix + "clients/:id",
          { id: "@id" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            create: {
              method: 'POST',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // conditions data model
        conditions: $resource(
          url + prefix + "conditions/:name",
          { name: "@name" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            create: {
              method: 'POST',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        // relations data model
        relations: $resource(
          url + prefix + "relations/:name",
          { name: "@name" },
          { query: {
              method: 'GET',
              isArray: true,
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                false,
                userCache
              )
            },
            get: {
              method: 'GET',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            save: {
              method: 'PUT',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            create: {
              method: 'POST',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            },
            delete: {
              method: 'DELETE',
              transformResponse: defaultTransform(
                $http.defaults.transformResponse,
                true,
                userCache
              )
            }
          }
        ),

        login: function (username, password) {
          return $http.post(url + prefix + "login", {
              username: username,
              password: password
            });
        },

        loginInfo: function (token) {
          return $http.get(url + prefix + "login/" + token, {cache: false});
        },

        logout: function (token) {
          return $http.delete(url + prefix + "logout/" + token);
        },

        getInfo: function () {
          return $http.get(url + "/info", {cache: false});
        },

        getResponse: function () {
          return $http.get(url + prefix + "response", {cache: false});
        },

        getConfig: function (params) {
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(url + prefix + "config", {cache: true});
        },

        getDiscounts: function (params) {
          var endpoint = url + prefix + "discounts" +
            (angular.isDefined(params) &&
              angular.isDefined(params.name) ? '/' + params.name : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getConditions: function (params) {
          var endpoint = url + prefix + "conditions" +
            (angular.isDefined(params) &&
              angular.isDefined(params.name) ? '/' + params.name : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getGroups: function (params) {
          var endpoint = url + prefix + "groups" +
            (angular.isDefined(params) &&
              angular.isDefined(params.name) ? '/' + params.name : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        checkProviders: function (providers, config) {
          return $http.put(url + prefix + "check/providers", providers, config);
        },

        uploadProviders: function (providers, params) {
          return $http.put(url + prefix + "providers?token=" + (params.token || ''), providers);
        },

        getProviders: function (params) {
          var endpoint = url + prefix + "providers" +
            (angular.isDefined(params) &&
              angular.isDefined(params.name) ? '/' + params.name : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        checkProducts: function (products, config) {
          return $http.put(url + prefix + "check/products", products, config);
        },

        uploadProducts: function (products, params) {
          return $http.put(url + prefix + "products?token=" + (params.token || ''), products);
        },

        getProducts: function (params) {
          var endpoint = url + prefix + "products";
          if (angular.isDefined(params)) {
            endpoint = endpoint +
            (angular.isDefined(params.group) ? '/' + params.group : '') +
            (angular.isDefined(params.name) ? '/' + params.name : '');
          }
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getVersions: function (params) {
          var endpoint = url + prefix + "versions" +
            (angular.isDefined(params) ||
              angular.isDefined(params.number) ? '/' + params.number : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getReleases: function (params) {
          var endpoint = url + prefix + "releases";
          if (angular.isDefined(params)) {
            endpoint = endpoint +
            (angular.isDefined(params.edition) ? '/' + params.edition : '') +
            (angular.isDefined(params.group) ? '/' + params.group : '') +
            (angular.isDefined(params.product) ? '/' + params.product : '');
          }
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getEditions: function (params) {
          var endpoint = url + prefix + "editions";
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getPrice: function (params) {
          var endpoint = url + prefix + "prices";
          if (angular.isDefined(params)) {
            endpoint = endpoint +
            (angular.isDefined(params.group) ? '/' + params.group : '') +
            (angular.isDefined(params.product) ? '/' + params.product : '') +
            (angular.isDefined(params.provider) ? '/' + params.provider : '') +
            (angular.isDefined(params.article) ? '/' + params.article : '') +
            (angular.isDefined(params.operation) ? '/' + params.operation : '') +
            (angular.isDefined(params.quantity) ? '/' + params.quantity : '') +
            (angular.isDefined(params.version) ? '?version=' + params.version : '');
          }
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        checkPrices: function (prices, config) {
          return $http.put(url + prefix + "check/prices", prices, config);
        },

        uploadPrices: function (prices, params) {
          return $http.put(url + prefix + "prices?token=" + (params.token || ''), prices);
        },

        getPrices: function (params) {
          var endpoint = url + prefix + "prices";
          if (angular.isDefined(params)) {
            endpoint = endpoint +
            (angular.isDefined(params.group) ? '/' + params.group : '') +
            (angular.isDefined(params.product) ? '/' + params.product : '') +
            (angular.isDefined(params.provider) ? '/' + params.provider : '');
            if (angular.isDefined(params.version) || angular.isDefined(params.legacy) || angular.isDefined(params.regular)) {
              var query = "";
              if (angular.isDefined(params.version)) {
                query = query + "&version=" + params.version;
              }
              if (angular.isDefined(params.legacy)) {
                query = query + "&legacy=" + params.legacy;
              }
              if (angular.isDefined(params.regular)) {
                query = query + "&regular=" + params.regular;
              }
              if (angular.isDefined(params.token) && params.token != 1) {
                query = query + "&token=" + params.token;
              }
              endpoint = endpoint + '?' + _.trim(query, '&');
            }
          }
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getPromotions: function (params) {
          var endpoint = url + prefix + "promotions" +
            (angular.isDefined(params) &&
              angular.isDefined(params.id) ? '/' + params.id : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        },

        getClients: function (params) {
          var endpoint = url + prefix + "clients" +
            (angular.isDefined(params) &&
              angular.isDefined(params.id) ? '/' + params.id : '');
          var cacheStatus = angular.isDefined(params) &&
            angular.isDefined(params.cache) ? params.cache : cache;
          if (!cacheStatus) {
            $cacheFactory.get('$http').remove(endpoint);
          }
          return $http.get(endpoint, {cache: true});
        }
      };
    };
  });

})();
